import { accessConfigGetSunpayStationLists } from '@sunwisesoftware/client-aftersales-js';

import * as creditFileSelectors from '../../creditFile/selectors';
import {
    FETCH_POWER_STATIONS,
    FETCH_POWER_STATIONS_FAILURE,
    FETCH_POWER_STATIONS_SUCCESS,
} from '../actionTypes';
import { powerStationsActions } from '../reducer';

export default (accessKeyId, filter) => (dispatch, getState) => {
    const companyId = creditFileSelectors.getCreditInstallerId(getState());
    dispatch(powerStationsActions[FETCH_POWER_STATIONS]());

    accessConfigGetSunpayStationLists({
        path: {
            company_sk_id: accessKeyId,
        },
        query: { ...filter, company_id: companyId },
    })
        .then((response) => {
            dispatch(
                powerStationsActions[FETCH_POWER_STATIONS_SUCCESS](
                    response?.data,
                ),
            );
        })
        .catch(() => {
            dispatch(powerStationsActions[FETCH_POWER_STATIONS_FAILURE]());
        });
};
